

export default class jsonLinkExportModel {

    level=''
    source=''
    sourceExacte=''
    destination=''


    constructor(LINK) {
        this.level=LINK.level+1 // pour que UNIVERS=0
        this.source=LINK.from
        this.sourceExacte=LINK.fromExact
        this.destination=LINK.to
    }



}